var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-button"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm"},on:{"click":function($event){return _vm.print()}}},[_c('shs-icon',{attrs:{"name":"print"}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }